import {
    AfterContentInit,
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChildren,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    Output,
    QueryList,
    SimpleChanges,
    TemplateRef,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IField } from '../../models/field/field.model';
import { createFormGroup } from '../../utils/form.util';
import { GenericFieldAddonDirective } from './generic-directives/generic-field-addon.directive';
import { GenericFieldDirective } from './generic-directives/generic-field.directive';

@Component({
    selector: 'mat-generic-input',
    templateUrl: './generic-input.component.html',
    styleUrls: [ './generic-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericInputComponent implements OnChanges, AfterContentInit, AfterViewInit {

    @Input()
    public fields: IField[];

    @Input()
    public inputFormGroup: UntypedFormGroup;

    @Input()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public initialValue: any;

    @Input()
    public disabled: boolean;

    @Input()
    public fieldTemplates: Record<string, GenericFieldDirective> = {};

    @Output()
    public inputFormGroupChange: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();

    @ContentChildren(GenericFieldAddonDirective)
    public fieldAddonDirectives: QueryList<GenericFieldAddonDirective>;

    @ContentChildren(GenericFieldDirective)
    public fieldDirectives: QueryList<GenericFieldDirective>;

    @HostListener('document:keyup.enter', [ '$event' ])
    public enterDown: (event: KeyboardEvent) => void = this.onEnter;

    public fieldAddonTemplates$: BehaviorSubject<Record<string, TemplateRef<unknown>[]>> = new BehaviorSubject<Record<string, TemplateRef<unknown>[]>>({});

    constructor() {
    }

    public ngOnChanges(simpleChanges: SimpleChanges): void {
        if (!this.inputFormGroup) {
            this.inputFormGroup = createFormGroup<unknown>(this.fields, this.initialValue);
            this.inputFormGroupChange.emit(this.inputFormGroup);
        }
        if (simpleChanges.disabled && this.inputFormGroup) {
            this.disabled ? this.inputFormGroup.disable({ emitEvent: false }) : this.inputFormGroup.enable({ emitEvent: false });
        }
    }

    public ngAfterContentInit(): void {
        this.fieldAddonDirectives.forEach((x: GenericFieldAddonDirective) => {
            const template: TemplateRef<unknown> = x.template;
            const matAddonField: string | string[] = x.matAddonField;
            if (matAddonField instanceof Array) {
                for (const field of matAddonField) {
                    if (!this.fieldAddonTemplates$.value[ field ]) {
                        this.fieldAddonTemplates$.value[ field ] = [];
                    }
                    this.fieldAddonTemplates$.value[ field ].push(template);
                }
            } else if (matAddonField) {
                if (!this.fieldAddonTemplates$.value[ matAddonField ]) {
                    this.fieldAddonTemplates$.value[ matAddonField ] = [];
                }
                this.fieldAddonTemplates$.value[ matAddonField ].push(template);
            } else {
                for (const field of this.fields) {
                    if (!this.fieldAddonTemplates$.value[ field.field ]) {
                        this.fieldAddonTemplates$.value[ field.field ] = [];
                    }
                    this.fieldAddonTemplates$.value[ field.field ].push(template);
                }
            }
        });
        this.fieldAddonTemplates$.next(this.fieldAddonTemplates$.value);

        this.fieldDirectives.forEach((x: GenericFieldDirective) => {
            if (x.matField instanceof Array) {
                for (const field of x.matField) {
                    this.fieldTemplates[ field ] = x;
                }
            } else {
                this.fieldTemplates[ x.matField ] = x;
            }
        });
    }

    public ngAfterViewInit(): void {
        // if (this.initialValue) {
        //     for (const field of this.fields) {
        //         this.inputFormGroup.controls[ field.field ].setValue(this.initialValue[ field.field ], { onlySelf: false, emitEvent: true });
        //     }
        // }
    }

    private onEnter(e: KeyboardEvent): void {
        e.preventDefault();
        e.stopImmediatePropagation();

        const el: HTMLElement = document.activeElement.closest('.generic-input-item');
        if (el) {
            let sibling: HTMLElement = el.nextElementSibling as HTMLElement;
            while (sibling) {
                if (sibling.className.indexOf('generic-input-item') > -1) {
                    (sibling.querySelector('input') || sibling.querySelector('mat-select'))?.focus();
                    break;
                } else {
                    sibling = sibling.nextElementSibling as HTMLElement;
                }
            }
        }
    }


}
